import React, { useState } from 'react';
import './input.scss';

export const Input = ({
  type = 'text',
  value = '',
  placeholder = 'Start typing...',
  error = false,
  errorText = '',
  inputLimitError,
  inputStyleProps = {},
  maxLimit = 100,
  showMaxLimit = true,
  name = '',
  disabled = false,
  onChange = () => {},
  onKeyDown = () => {},
  ...props
}) => {
  const [inputVal, setInputVal] = useState(value);
  const errorClass = error ? 'error' : '';
  const limitErrorClass = inputLimitError ? 'limitError' : '';

  const handleChange = (event) => {
    const value = event.target.value;
    setInputVal(value);
    onChange(value);
  };

  const filterInput = (e) => {
    if (e.target.type === 'number' && e.key === 'e') {
      e.preventDefault();
    }
    onKeyDown(e);
  };

  const onWheel = (e) => {
    e.target.blur();
  };

  return (
    <React.Fragment>
      <input
        className={`inputBox medium ${errorClass} ${limitErrorClass}`}
        type={type}
        style={{ ...inputStyleProps }}
        value={inputVal}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        onKeyDown={filterInput}
        maxLength={maxLimit}
        disabled={disabled}
        onWheel={onWheel}
        {...props}
      />
      {error && errorText && <p className='errorText'>{errorText}</p>}
      {showMaxLimit && (
        <p className='light note small '>
          Maximum {maxLimit} characters allowed
        </p>
      )}
    </React.Fragment>
  );
};
